import useApiMutation from '_api/mutations/useApiMutation';

export const RESET_PASSWORD_REQUEST = 'reset-password-request';

export const usePasswordResetRequest = () => {
  return useApiMutation<{ confirmationCode: string }, { email: string }>(
    () => '/user/password-reset-request',
    'post',
    undefined,
    {
      mutationKey: [RESET_PASSWORD_REQUEST],
    },
    (body: { email: string }) => JSON.stringify(body),
  );
};
